<div class="grid-container margin-top">
  @if (isLoading == false) {
    <div class="grid-x" [formGroup]="form">
      <div class="cell large-12 medium-12 small-12">
        <h3 class="h4">Available Settings:</h3>
      </div>
      <div class="cell large-5 medium-5 small-5 bold text-align-center">
        Setting
      </div>
      <div class="cell large-5 medium-5 small-5 bold text-align-center">
        Current Value
      </div>
      <div class="cell large-2 medium-2 small-2 bold">
        &nbsp;
      </div>
      @for (setting of currentSettings; track setting) {
        <div class="cell large-5 medium-5 small-5 border-one-pixel-solid text-align-left padding-left padding-top">
          {{ setting.settingName }}
        </div>
        <div class="cell large-5 medium-5 small-5 border-one-pixel-solid text-align-center padding-top">
          <div class="centered-cell">
            @if (setting.isActive != null) {
              <input class="show-for-sr" type="checkbox" [id]="setting.id" [formControlName]="setting.id" (ngModelChange)="change(setting)">
              <div class="toggle-background">
                <div class="choice-bar" [ngClass]="{ 'active': form?.get(setting.id.toString())?.value, 'inactive': form?.get(setting.id.toString())?.value === false, 'disabled': form?.get(setting.id.toString())?.disabled }">
                  <div class="choice" (click)="change(setting, false)">On</div>
                  <label [for]="setting.id" class="thumb wrap-text"></label>
                  <div class="choice" (click)="change(setting, true)">Off</div>
                </div>
              </div>
            }
            @if (setting.isActive == null) {
              <select [formControlName]="setting.id" (ngModelChange)="setDirty()">
                @for (opt of setting.systemSettingsOptions; track opt) {
                  <option [value]="opt.optionValue">{{opt.optionDisplay}}</option>
                }
              </select>
            }
          </div>
        </div>
        <div class="cell large-2 medium-2 small-2 border-one-pixel-solid text-align-center padding-top">
          <button class="button" (click)="editSetting(setting)">
            Edit <svg-icon icon="icon-pencil" class="cursor-pointer white" aria-hidden="true"></svg-icon>
          </button>
        </div>
      }
    </div>
  } @else {
    <div class="grid-x">
      <div class="cell large-12 medium-12 small-12">
        <text-loader [run]="true" [interval]="1000" [tickType]="'.'" [text]="'Loading Settings'"></text-loader>
      </div>
    </div>
  }
</div>


